import { render } from "./EventsCalendar.vue?vue&type=template&id=c874242c&scoped=true&ts=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=ts"
export * from "./EventsCalendar.vue?vue&type=script&lang=ts"

import "./EventsCalendar.vue?vue&type=style&index=0&id=c874242c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c874242c"]])

export default __exports__